import { BaseHttpException } from '@zaoblako/shared/common/exceptions/base-http.exception';

/** `400 - Bad Request` HTTP error exception class */
export class BadRequestException<T = any> extends BaseHttpException<T> {
  public constructor(message?: string, options?: ErrorOptions) {
    super(400, 'BadRequestException', message || 'Bad Request', options);
  }
}
